<div class="col-xs-12 sp-0" *ngIf="grid">
    <tt-grid [(ttOptions)]="grid"></tt-grid>
</div>
